import React from 'react';
import { Link } from 'react-router-dom';
import { RISK_SERVICES } from '../data/siteData';
import { useScrollReveal } from '../hooks/useScrollReveal';
import Icon from '../components/Icon';
import './WealthManagement.css';
import riskManagementImage from '../assets/riskm.jpeg';

function RiskCard({ s, index }) {
  const { ref, visible } = useScrollReveal();
  // Encode the service name for URL
  const serviceName = encodeURIComponent(s.short || s.name);
  
  return (
    <div ref={ref} id={s.id} className={`wm-card${visible ? ' visible' : ''}`} style={{ transitionDelay: `${(index % 3) * 0.1}s` }}>
      <div className="wmc-top">
        <Icon icon={s.icon} className="wmc-icon" size={40} />
        <div className="wmc-header">
          <div className="wmc-name">{s.name}</div>
          <div className="wmc-tagline" style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{s.tagline}</div>
        </div>
      </div>
      <p className="wmc-desc">{s.desc}</p>
      <div className="wmc-features">
        {s.features.map((f, i) => (
          <div key={i} className="wmc-feature"><span>✦</span>{f}</div>
        ))}
      </div>
      <div className="wmc-footer">
        <Link to={`/service/risk/${s.id}`} className="btn-primary" style={{ fontSize: 12, padding: '11px 22px' }}>Learn More →</Link>
        {/* FIXED: Pass service name to contact page */}
        <Link to={`/contact?service=${serviceName}`} className="btn-ghost" style={{ fontSize: 12, padding: '11px 22px' }}>
          Get Quote
        </Link>
      </div>
    </div>
  );
}

export default function RiskManagement() {
  const { ref, visible } = useScrollReveal();
  return (
    <div className="wm-page page-wrapper">
      <div className="wm-hero">
        <div className="wm-hero-grid" />
        <div className="wm-hero-glow" style={{ background: 'radial-gradient(ellipse 60% 50% at 70% 50%, rgba(192,32,31,0.13), transparent)' }} />
        <div className="wm-hero-content">
          <div className="wm-hero-left">
            <div className="section-label" style={{ color: 'var(--red)' }}>Risk Management</div>
            <h1 className="section-title">
              Protect What<br /><span className="red">Matters Most</span>
            </h1>
            <p className="section-sub">
              Life Insurance, Health Insurance &amp; General Insurance — comprehensive protection for your family and assets.
            </p>
            <div className="wm-hero-actions">
              {/* FIXED: Pass risk management service name */}
              <Link to="/contact?service=Risk%20Management" className="btn-primary">Get Free Quote →</Link>
              <a href="tel:9849131273" className="btn-ghost">📞 9849131273</a>
            </div>
          </div>
          <div className="wm-hero-right">
             <img 
              src={riskManagementImage} 
              alt="Risk Management and Insurance Protection" 
              className="risk-hero-image"
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                borderRadius: '12px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                objectFit: 'cover'
              }}
            />
          </div>
        </div>
      </div>
      <section style={{ padding: '72px 0' }}>
        <div className="container">
          <div ref={ref} className={`section-header${visible ? ' reveal-visible' : ' reveal'}`} style={{ textAlign: 'center', marginBottom: 56 }}>
            <div className="section-label" style={{ justifyContent: 'center', color: 'var(--red)' }}>Insurance Services</div>
            <h2 className="section-title">Your Complete <span className="red">Protection Portfolio</span></h2>
          </div>
          <div className="wm-grid">
            {RISK_SERVICES.map((s, i) => <RiskCard key={s.id} s={s} index={i} />)}
          </div>
        </div>
      </section>
    </div>
  );
}